export const LOADER_KEY = {
  CREATE_DOCUMENT_METADATA: 0,
  UPDATE_DOCUMENT_METADATA: 1,
  UPDATE_DOCUMENT_METADATA_WITH_SMALL_FILE: 2,
  VALIDATE_DOCUMENT_METADATA: 3
} as const;

export type CpsLoaderKey = (typeof LOADER_KEY)[keyof typeof LOADER_KEY];
